import * as React from "react";
import * as yup from "yup";
import { Formik } from "formik";
import { FormControl, FormGroup, FormLabel } from "react-bootstrap";
import * as API from "../apiCalls";
import * as types from "../types";
import { SeatSelector } from "..";
import useSpectacleCart from "../hooks/useSpectacleCart";
import ReservationTimer from "./ReservationTimer";
import CartSummary from "./CartSummary";
import TicketSelector from "./TicketSelector";
import spectacle from "../../../../../backend/mockups/spectacle.json";
import {NotificationContainer, NotificationManager} from 'react-notifications';

const countries = ["POL"];
const countriesHuman = ["Polska"];
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const schema = yup.object({
  firstName: yup.string().required("Test"),
  lastName: yup.string().required("Test"),
  email: yup.string().required("Test"),
  phone: yup
    .string()
    .matches(phoneRegExp, "Numer jest niepoprawny")
    .required("Test"),
  country: yup.string(),
  invoice: yup.boolean().required(),
});

interface Props {
  spectacleId: number;
  seats: types.Seat[];
  lines: types.Line[];
  spectacle: types.Spectacle;
  areaPrices: { [key: string]: types.Price[] };
  vatPrices: any;

  labels: types.Label[];
  xMax: number;
  yMax: number;
  xMin: number;
  yMin: number;
}

const ReservationForm: React.FC<Props> = ({
  spectacleId,
  spectacle,
  ...rest
}) => {
  const seatSelectorElementRef: any = React.createRef();
  const paymentsRef: any = React.createRef();
  const {
    cart,
    selectSeat,
    unselectSeat,
    isSeatSelected,
    changeCartItemPrice,
    reservationTimer,
    cartSessionToken,
  } = useSpectacleCart(rest.areaPrices, spectacleId, spectacle.UnnumberedSeats, rest);

  const changePrice = (SeatId: number) => (e: React.ChangeEvent<any>) => {
    const value = e.currentTarget.value;

    changeCartItemPrice(SeatId, value);
  };

  const deleteFromCart = (SeatId: number) => (e: React.MouseEvent<any>) => {
    e.preventDefault()
    unselectSeat(SeatId);
  };
  const [hoverSeat, setHoverSeat] = React.useState<types.Seat | null>(null);

  const scrollToPayments = () => {
    if (paymentsRef.current) {
      paymentsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const cartItemInfo = spectacle.UnnumberedSeats
    ? "sr-only"
    : "d-flex flex-column";

  return (
    <>
      <div className="container-fluid module chair-select-module  mx-0 px-0">
        <div className="row justify-content-center module-header  mx-0 px-0">
          <div className="col-lg-9 mx-0 px-0">
            <p className="subtitle" style={{ color: `red` }}>BILETY ZAKUPIONE DROGĄ ELEKTRONICZNĄ NIE PODLEGAJĄ ZWROTOWI ORAZ WYMIANIE</p>
            <h5>
              <span className="ui buy-box step">
                1<em>/3</em>
              </span>
              Miejsca i bilety
            </h5>
            <p className="subtitle">
              Wybierz miejsca i rodzaj biletów, które chcesz zakupić
            </p>
          </div>
        </div>
        {/* tslint:disable-next-line:max-line-length*/}
        <div className="row module-content audience-wrap justify-content-center mx-0 px-0">
          <div
            className="col-xs-12 col-sm-12 col-lg-6 audience text-center mx-0 px-0"
            ref={seatSelectorElementRef}
          >
            {!spectacle.UnnumberedSeats ? (
              <>
                <SeatSelector
                  spectacle={spectacle}
                  spectacleId={spectacleId}
                  selectSeat={selectSeat}
                  unselectSeat={unselectSeat}
                  isSeatSelected={isSeatSelected}
                  seatSelectorElementRef={seatSelectorElementRef}
                  setHoverSeat={setHoverSeat}
                  {...rest}
                />

                <div className="legend">
                  <div className="legend-item">
                    <img src="/images/th-seat-white.svg" />
                    <p>Miejsce na sali</p>
                  </div>
                  <div className="legend-item">
                    <img src="/images/th-seat-taken.svg" />
                    <p>Miejsce już zajęte</p>
                  </div>
                  <div className="legend-item">
                    <img src="/images/th-seat-selected.svg" />
                    <p>Miejsce wybrane przez Ciebie</p>
                  </div>
                </div>
              </>
            ) : (
              <TicketSelector
                spectacle={spectacle}
                spectacleId={spectacleId}
                selectSeat={selectSeat}
                unselectSeat={unselectSeat}
                isSeatSelected={isSeatSelected}
                cart={cart}
                {...rest}
              />
            )}
          </div>

          <div className="col-lg-5 summarize sum-dark">
            <h6>
              Wskazane miejsce:
              {hoverSeat !== null
                ? `${hoverSeat.Sector} ${hoverSeat.Number}`
                : null}
            </h6>
            <h6>Wybrano miejsca:</h6>

            <form className="form ticket-selection">
              {cart.map((cartItem: types.CartItem, index) => {
                return (
                  <div className="form-group row justify-content-center ticket" key={index}>
                    <label className="col-lg-5 col-12">
                      <span className="ui step">{index + 1}</span>

                      <span className={cartItemInfo}>
                        <span>{cartItem.Sector}</span>
                        <span>Rząd: {cartItem.Row}</span>
                        <span>Miejsce: {cartItem.Number}</span>
                      </span>
                    </label>
                    <div className="col-lg-5 col-9 select-wrap ">
                      <select
                        className="form-control"
                        onChange={changePrice(cartItem.SeatId)}
                        value={cartItem.PriceId}
                      >
                        {rest.areaPrices[cartItem.PriceAreaId].map(
                          (price: types.Price, index) => {
                            return (
                              <option value={price.PriceId} key={index}>
                                Bilet {price.Name}: {price.Value} zł
                              </option>
                            );
                          },
                        )}
                      </select>
                    </div>
                    <div className="col-lg-2 col text-right">
                      <button
                        type="button"
                        className="btn btn-outline-light"
                        onClick={deleteFromCart(cartItem.SeatId)}
                      >
                        <span className="icon-trash-2 solo"></span>
                      </button>
                    </div>
                  </div>
                );
              })}

              <div className="form-group row price-summary text-right">
                <p className="price w-100 p-5">
                  <span className="h4">Suma: </span>
                  <span className="h4">
                    {cart
                      .map(cartItem => cartItem.PriceValue)
                      .reduce((a, b) => a + b, 0)}
                  </span>
                  <span className="h5">zł</span>
                </p>
              </div>
              <button
                type="button"
                className="form-control btn btn-light btn-lg"
                onClick={scrollToPayments}
              >
                Przejdź do płatności <span className="icon-chevron-down"></span>
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="container-fluid module payment-section" ref={paymentsRef}>
        <div className="row justify-content-center">
          <Formik
            validationSchema={schema}
            onSubmit={(values, actions) => {
              actions.setSubmitting(true);

              if (cart.length === 0) {
                actions.setStatus({
                  error: "Musisz wybrać przynajmniej jedno siedzenie!",
                });

                actions.setSubmitting(false);

                return;
              }

              if (cartSessionToken === null) {
                actions.setStatus({
                  error: "Wystąpił błąd spróbuj później!",
                });

                actions.setSubmitting(false);

                return;
              }

              API.createPayment({
                cart,
                spectacleId,
                token: cartSessionToken,
                payer: {
                  ...values,
                },
              })
                .then(response => {
                  if (response.status !== 201) {
                    throw Error();
                  }

                  return response.json();
                })
                .then(result => {
                  if(result.isFree) {

                    const body = {
                      id: result.free.shopId,
                      control: result.free.control,
                      email: result.free.email,
                      operation_number: '000000',
                      operation_status: 'completed',
                      operation_type: 'payment',
                      operation_amount: 0.00,
                      operation_currency: 'PLN',
                      is_completed: true,
                    }

                    fetch("https://bilety.teatr.torun.pl/api/payments/notify", {
                      method: "POST",
                      headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify(body),
                    });

                    let location = "https://bilety.teatr.torun.pl/#/ticketBought"
                    document.location.href = location;

                    // NotificationManager.success(
                    //   "Dziękujemy za zakup biletów.",
                    //   "Za chwilę otrzymasz maila z biletami.",
                    //   6000,
                    // );
                  }
                  else document.location.href = result.data;
                })
                .catch(error => {
                  actions.setStatus({
                    error: "Wystąpił błąd spróbuj później!",
                  });
                })
                .finally(() => {
                  actions.setSubmitting(false);
                });
            }}
            initialValues={{
              email: "",
              firstName: "",
              lastName: "",
              phone: "",
              country: countries[0],
              invoice: false,
              city: "",
              street: "",
              buildingNumber: "",
              postcode: "",
              region: "",
              invoicePerson: false,
              invoiceCompany: "",
              invoiceNip: "",
              invoiceCity: "",
              invoiceStreet: "",
              invoiceBuildingNumber: "",
              invoicePostcode: "",
            }}
          >
            {({
              handleSubmit,
              setFieldValue,
              handleChange,
              handleBlur,
              values,
              touched,
              errors,
              status,
            }) => (
              <form
                onSubmit={handleSubmit}
                className="w-100 row justify-content-center"
              >
                <div className="col-lg-5">
                  <div className="module-header">
                    <h5>
                      <span className="ui buy-box step">
                        2<em>/3</em>
                      </span>
                      Dane do zakupu
                    </h5>
                    <p className="subtitle">Podaj dane osoby kupującej</p>
                  </div>
                  {reservationTimer ? <ReservationTimer /> : null}
                  <ul className="cart container"></ul>
                  <div>
                    <div className="form-group row">
                      <div className="col-md-6">
                        <span className="m-1">*</span>
                        <FormLabel htmlFor="name">Imię</FormLabel>
                        <FormControl
                          id="name"
                          type="text"
                          name="firstName"
                          placeholder="Imię"
                          value={values.firstName}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          isValid={touched.firstName && !errors.firstName}
                          isInvalid={touched.firstName && !!errors.firstName}
                        />
                      </div>
                      <div className="col-md-6">
                        <span className="m-1">*</span>
                        <FormLabel htmlFor="lastName">Nazwisko</FormLabel>
                        <FormControl
                          id="lastName"
                          type="text"
                          name="lastName"
                          placeholder="Nazwisko"
                          value={values.lastName}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          isValid={touched.lastName && !errors.lastName}
                          isInvalid={touched.lastName && !!errors.lastName}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <span className="m-1">*</span>
                      <FormLabel htmlFor="email">E-mail</FormLabel>
                      <FormControl
                        id="email"
                        type="email"
                        name="email"
                        placeholder="E-mail"
                        value={values.email}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isValid={touched.email && !errors.email}
                        isInvalid={touched.email && !!errors.email}
                      />
                    </div>
                    <div className="form-group">
                      <span className="m-1">*</span>
                      <FormLabel htmlFor="phone">Telefon</FormLabel>
                      <FormControl
                        type="text"
                        name="phone"
                        id="phone"
                        value={values.phone}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isValid={touched.phone && !errors.phone}
                        isInvalid={touched.phone && !!errors.phone}
                      />
                    </div>

                    <FormGroup>
                      <span className="m-1"></span>
                      <label htmlFor="country">Kraj</label>
                      <FormControl
                        as="select"
                        id="country"
                        name="country"
                        value={values.country}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isValid={touched.country && !errors.country}
                        isInvalid={touched.country && !!errors.country}
                      >
                        {countries.map((country, index) => {
                          return (
                            <option value={country} key={index}>
                              {countriesHuman[index]}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>

                    <div className="form-group row">
                      <div className="col-md-8">
                        <span className="m-1"></span>
                        <label htmlFor="street">Adres</label>
                        <FormControl
                          className="form-control form-control-lg"
                          type="text"
                          placeholder="Nazwa ulicy"
                          name="street"
                          id="street"
                          value={values.street}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          isValid={touched.street && !errors.street}
                          isInvalid={touched.street && !!errors.street}
                        />
                      </div>
                      <div className="col-md-4">
                        <span className="m-1"></span>
                        <label htmlFor="buildingNumber">
                          Numer budynku / lokalu
                        </label>
                        <FormControl
                          className="form-control form-control-lg"
                          type="text"
                          name="buildingNumber"
                          placeholder="1 / 112"
                          value={values.buildingNumber}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          isValid={
                            touched.buildingNumber && !errors.buildingNumber
                          }
                          isInvalid={
                            touched.buildingNumber && !!errors.buildingNumber
                          }
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-md-4">
                        <span className="m-1"></span>
                        <label htmlFor="postcode">Kod pocztowy</label>
                        <FormControl
                          className="form-control form-control-lg"
                          type="text"
                          name="postcode"
                          id="postcode"
                          placeholder="00-000"
                          value={values.postcode}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          isValid={touched.postcode && !errors.postcode}
                          isInvalid={touched.postcode && !!errors.postcode}
                        />
                      </div>
                      <div className="col-md-8">
                        <span className="m-1"></span>
                        <label htmlFor="city">Miasto</label>
                        <FormControl
                          className="form-control form-control-lg"
                          type="text"
                          name="city"
                          id="city"
                          placeholder="Miasto"
                          value={values.city}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          isValid={touched.city && !errors.city}
                          isInvalid={touched.city && !!errors.city}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <span className="m-1"></span>
                      <FormLabel htmlFor="region">Województwo:</FormLabel>
                      <FormControl
                        type="text"
                        name="region"
                        id="region"
                        value={values.region}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        isValid={touched.region && !errors.region}
                        isInvalid={touched.region && !!errors.region}
                      />
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="invoice"
                        checked={values.invoice === true}
                        onChange={() => {
                          if (values.invoicePerson && !values.invoice) {
                            setFieldValue(
                              "invoicePerson",
                              !values.invoicePerson,
                            );
                          }

                          setFieldValue("invoice", !values.invoice);
                        }}
                      />
                      <label className="form-check-label" htmlFor="invoice">
                        Poproszę fakturę (firma)
                      </label>
                    </div>

                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        value=""
                        id="invoice"
                        checked={values.invoicePerson === true}
                        onChange={() => {
                          if (values.invoice && !values.invoicePerson) {
                            setFieldValue("invoice", !values.invoice);
                          }

                          setFieldValue("invoicePerson", !values.invoicePerson);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="invoicePerson"
                      >
                        Poproszę fakturę (osoba prywatna)
                      </label>
                    </div>

                    {values.invoice ? (
                      <>
                        <div className="form-group row">
                          <div className="col-md-8">
                            <label htmlFor="invoiceCompany">Nazwa firmy</label>
                            <FormControl
                              disabled={!values.invoice}
                              className="form-control form-control-lg"
                              type="text"
                              name="invoiceCompany"
                              id="invoiceCompany"
                              placeholder="Nazwa firmy"
                              value={values.invoiceCompany}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isValid={
                                touched.invoiceCompany && !errors.invoiceCompany
                              }
                              isInvalid={
                                touched.invoiceCompany &&
                                !!errors.invoiceCompany
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="invoiceNip">NIP</label>
                            <FormControl
                              disabled={!values.invoice}
                              className="form-control form-control-lg"
                              type="text"
                              placeholder="0000000000"
                              name="invoiceNip"
                              id="invoiceNip"
                              value={values.invoiceNip}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isValid={touched.invoiceNip && !errors.invoiceNip}
                              isInvalid={
                                touched.invoiceNip && !!errors.invoiceNip
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-8">
                            <label htmlFor="invoiceStreett">Adres</label>
                            <FormControl
                              disabled={!values.invoice}
                              className="form-control form-control-lg"
                              type="text"
                              placeholder="Nazwa ulicy"
                              name="invoiceStreet"
                              id="invoiceStreet"
                              value={values.invoiceStreet}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isValid={
                                touched.invoiceStreet && !errors.invoiceStreet
                              }
                              isInvalid={
                                touched.invoiceStreet && !!errors.invoiceStreet
                              }
                            />
                          </div>
                          <div className="col-md-4">
                            <label htmlFor="invoiceBuildingNumber">
                              Numer budynku / lokalu
                            </label>
                            <FormControl
                              disabled={!values.invoice}
                              className="form-control form-control-lg"
                              type="text"
                              name="invoiceBuildingNumber"
                              placeholder="1 / 112"
                              value={values.invoiceBuildingNumber}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isValid={
                                touched.invoiceBuildingNumber &&
                                !errors.invoiceBuildingNumber
                              }
                              isInvalid={
                                touched.invoiceBuildingNumber &&
                                !!errors.invoiceBuildingNumber
                              }
                            />
                          </div>
                        </div>
                        <div className="form-group row">
                          <div className="col-md-4">
                            <label htmlFor="invoicePostcode">
                              Kod pocztowy
                            </label>
                            <FormControl
                              disabled={!values.invoice}
                              className="form-control form-control-lg"
                              type="text"
                              name="invoicePostcode"
                              id="invoicePostcode"
                              placeholder="00-000"
                              value={values.invoicePostcode}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isValid={
                                touched.invoicePostcode &&
                                !errors.invoicePostcode
                              }
                              isInvalid={
                                touched.invoicePostcode &&
                                !!errors.invoicePostcode
                              }
                            />
                          </div>

                          <div className="col-md-8">
                            <label htmlFor="invoiceCity">Miejscowość</label>
                            <FormControl
                              disabled={!values.invoice}
                              className="form-control form-control-lg"
                              type="text"
                              name="invoiceCity"
                              id="invoiceCity"
                              placeholder="Nazwa miejscowości"
                              value={values.invoiceCity}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              isValid={
                                touched.invoiceCity && !errors.invoiceCity
                              }
                              isInvalid={
                                touched.invoiceCity && !!errors.invoiceCity
                              }
                            />
                          </div>
                        </div>
                      </>
                    ) : null}
                  </div>
                </div>

                <div className="col-lg-4">
                  <div className="module-header">
                    <h5>
                      <span className="ui buy-box step">
                        3<em>/3</em>
                      </span>
                      Podsumowanie
                    </h5>
                    <p className="subtitle">Dokonaj płatności</p>
                  </div>

                  <CartSummary
                    spectacle={spectacle}
                    changePrice={changePrice}
                    cart={cart}
                    areaPrices={rest.areaPrices}
                    cartItemInfo={cartItemInfo}
                    unselectSeat={deleteFromCart}
                  />
                </div>
              </form>
            )}
          </Formik>
          <NotificationContainer/>
        </div>
      </div>
    </>
  );
};

export default ReservationForm;
